"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logAppEntry = logAppEntry;
var _browserLogs = require("@datadog/browser-logs");
/**
 *
 * @param {object} user
 * @param {string} meetingUserId
 * @param {string} meetingId
 * @param {string} meetingType
 */
function logAppEntry(user, meetingUserId, meetingId, meetingType) {
  var messageContext = {
    logger: {
      name: 'studio-app-entry'
    }
  };
  var userName = user.firstName + ' ' + user.lastName;
  var userId = user._id;
  var message = "User: ".concat(userName, " entered. UserId: ").concat(userId, " Meeting UserId: ").concat(meetingUserId, " Meeting Id: ").concat(meetingId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.user.id', userId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.meeting.id', meetingId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.meeting.user.id', meetingUserId);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.user.name', userName);
  _browserLogs.datadogLogs.setGlobalContextProperty('studio.meeting.meetingType', meetingType);

  // setting these duplicate fields to help us align with some RUM metrics until WEBINAR-24489
  _browserLogs.datadogLogs.setGlobalContextProperty('userId', userId);
  _browserLogs.datadogLogs.setGlobalContextProperty('meetingId', meetingId);
  if (navigator.hardwareConcurrency) {
    messageContext['hardwareConcurrency'] = navigator.hardwareConcurrency;
  }
  if (navigator.deviceMemory) {
    messageContext['deviceMemory'] = navigator.deviceMemory;
  }
  _browserLogs.datadogLogs.logger['info'](message, messageContext);
}